/* LUVEA — egalisation des rangees dans les carrousels produits (Slick a 2 rangees).
   Chaque colonne Slick empile ses cartes independamment : une carte plus haute
   (titre plus long, image differente) pousse celle du dessous et desaligne les
   rangees. Ici on MESURE le vrai DOM : pour chaque rangee, on prend la carte la
   plus haute et on impose cette hauteur (min-height) a toutes les cartes de la
   rangee -> la rangee suivante demarre a la meme hauteur dans toutes les
   colonnes. Aucun texte coupe. Passes bornees (pas de MutationObserver). */
(function () {
  function egaliser() {
    document.querySelectorAll('.feature-product .slick-track').forEach(function (track) {
      var slides = [].slice.call(track.children).filter(function (s) {
        return s.classList && s.classList.contains('slick-slide');
      });
      if (!slides.length) return;
      var nbRangees = 0;
      slides.forEach(function (s) { nbRangees = Math.max(nbRangees, s.children.length); });
      for (var r = 0; r < nbRangees; r++) {
        var cartes = [];
        slides.forEach(function (s) {
          var w = s.children[r];
          if (!w) return;
          var it = w.querySelector('.product-item') || w;
          cartes.push(it);
        });
        if (cartes.length < 2) continue;
        var max = 0;
        cartes.forEach(function (it) {
          it.style.minHeight = '';
          var h = it.getBoundingClientRect().height;
          if (h > max) max = h;
        });
        if (max < 40) continue; /* pas encore rendu (images pas chargees) */
        cartes.forEach(function (it) { it.style.minHeight = Math.ceil(max) + 'px'; });
      }
    });
  }
  /* Passes bornees : Slick s'initialise puis les images lazyload arrivent. */
  var n = 0;
  var t = setInterval(function () { egaliser(); if (++n >= 10) clearInterval(t); }, 700);
  if (document.readyState !== 'loading') egaliser();
  else document.addEventListener('DOMContentLoaded', egaliser);
  window.addEventListener('load', function () { setTimeout(egaliser, 300); });
  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt); rt = setTimeout(egaliser, 200);
  });
})();
